import { useEffect, useState } from "react";

const STORAGE_KEY = "megapack-offer-deadline";

/** Fecha límite personal: 24 h desde la primera visita, guardada en el navegador del visitante */
function getPersonalDeadline(hours: number) {
  const now = Date.now();
  try {
    const saved = Number(window.localStorage.getItem(STORAGE_KEY));
    if (saved && saved > 0) return saved;
    const deadline = now + hours * 3600 * 1000;
    window.localStorage.setItem(STORAGE_KEY, String(deadline));
    return deadline;
  } catch {
    return now + hours * 3600 * 1000;
  }
}

/**
 * Cuenta regresiva. Con una fecha fija (target) la usa;
 * si target es null, corre `hours` horas desde la primera visita.
 */
export function useCountdown(target: string | null, hours = 24) {
  const [targetMs] = useState(() =>
    target ? new Date(target).getTime() : getPersonalDeadline(hours)
  );
  const [remaining, setRemaining] = useState(() => Math.max(0, targetMs - Date.now()));

  useEffect(() => {
    const tick = () => setRemaining(Math.max(0, targetMs - Date.now()));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [targetMs]);

  const totalSeconds = Math.floor(remaining / 1000);
  return {
    ended: remaining <= 0,
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
}
